import Link from 'next/link';
import React from 'react';
import { useTranslation } from 'react-i18next';

const LearnMoreLink: React.FC<{ url: string }> = ({ url }) => {
  const { t } = useTranslation('common');

  return (
    <Link prefetch={false} legacyBehavior passHref href={url}>
      <a
        target='_blank'
        className='whitespace-nowrap text-14 text-primary-60 underline'
        onClick={(e) => e.stopPropagation()}
      >
        {t('learn-more')}
      </a>
    </Link>
  );
};

export { LearnMoreLink };
